/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    ArticleAdminModel,
    ArticleCreateModel,
    ArticleModel,
    ArticleUpdateModel,
    HTTPValidationError,
    ListArticleAdminResponse,
    ListArticleResponse,
    ResponseGetArticleApiV1ArticlesArticleGet,
    ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet,
    Search,
    Type,
} from '../models/index';
import {
    ArticleAdminModelFromJSON,
    ArticleAdminModelToJSON,
    ArticleCreateModelFromJSON,
    ArticleCreateModelToJSON,
    ArticleModelFromJSON,
    ArticleModelToJSON,
    ArticleUpdateModelFromJSON,
    ArticleUpdateModelToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ListArticleAdminResponseFromJSON,
    ListArticleAdminResponseToJSON,
    ListArticleResponseFromJSON,
    ListArticleResponseToJSON,
    ResponseGetArticleApiV1ArticlesArticleGetFromJSON,
    ResponseGetArticleApiV1ArticlesArticleGetToJSON,
    ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGetFromJSON,
    ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGetToJSON,
    SearchFromJSON,
    SearchToJSON,
    TypeFromJSON,
    TypeToJSON,
} from '../models/index';

export interface CreateArticleApiV1ArticlesArticlePostRequest {
    articleCreateModel: ArticleCreateModel;
}

export interface DeleteArticleApiV1ArticlesArticleDeleteRequest {
    id: string;
}

export interface GetArticleAdminApiV1ArticlesArticleAdminGetRequest {
    id: string;
}

export interface GetArticleApiV1ArticlesArticleGetRequest {
    id: string;
}

export interface GetArticlesAdminApiV1ArticlesAdminGetRequest {
    limit?: number;
    offset?: number;
}

export interface GetArticlesApiV1ArticlesGetRequest {
    type?: Type;
    search?: Search;
    limit?: number;
    offset?: number;
}

export interface PublishArticleApiV1ArticlesArticlePublishPostRequest {
    id: string;
}

export interface SetFeaturedArticleApiV1ArticlesArticleSetFeaturedPutRequest {
    id: string;
}

export interface UnpublishArticleApiV1ArticlesArticleUnpublishPostRequest {
    id: string;
}

export interface UpdateArticleApiV1ArticlesArticlePutRequest {
    id: string;
    articleUpdateModel: ArticleUpdateModel;
}

/**
 *
 */
export class ArticlesApi extends runtime.BaseAPI {
    /**
     * Create article
     * Create Article
     */
    async createArticleApiV1ArticlesArticlePostRaw(
        requestParameters: CreateArticleApiV1ArticlesArticlePostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ArticleModel>> {
        if (requestParameters['articleCreateModel'] == null) {
            throw new runtime.RequiredError(
                'articleCreateModel',
                'Required parameter "articleCreateModel" was null or undefined when calling createArticleApiV1ArticlesArticlePost().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/article`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ArticleCreateModelToJSON(requestParameters['articleCreateModel']),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ArticleModelFromJSON(jsonValue),
        );
    }

    /**
     * Create article
     * Create Article
     */
    async createArticleApiV1ArticlesArticlePost(
        requestParameters: CreateArticleApiV1ArticlesArticlePostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ArticleModel> {
        const response = await this.createArticleApiV1ArticlesArticlePostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete article
     * Delete Article
     */
    async deleteArticleApiV1ArticlesArticleDeleteRaw(
        requestParameters: DeleteArticleApiV1ArticlesArticleDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteArticleApiV1ArticlesArticleDelete().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/article`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete article
     * Delete Article
     */
    async deleteArticleApiV1ArticlesArticleDelete(
        requestParameters: DeleteArticleApiV1ArticlesArticleDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<any> {
        const response = await this.deleteArticleApiV1ArticlesArticleDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get article by id - admin route
     * Get Article Admin
     */
    async getArticleAdminApiV1ArticlesArticleAdminGetRaw(
        requestParameters: GetArticleAdminApiV1ArticlesArticleAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ArticleAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getArticleAdminApiV1ArticlesArticleAdminGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/article/admin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ArticleAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Get article by id - admin route
     * Get Article Admin
     */
    async getArticleAdminApiV1ArticlesArticleAdminGet(
        requestParameters: GetArticleAdminApiV1ArticlesArticleAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ArticleAdminModel> {
        const response = await this.getArticleAdminApiV1ArticlesArticleAdminGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get article by id
     * Get Article
     */
    async getArticleApiV1ArticlesArticleGetRaw(
        requestParameters: GetArticleApiV1ArticlesArticleGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ResponseGetArticleApiV1ArticlesArticleGet>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getArticleApiV1ArticlesArticleGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/articles/article`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ResponseGetArticleApiV1ArticlesArticleGetFromJSON(jsonValue),
        );
    }

    /**
     * Get article by id
     * Get Article
     */
    async getArticleApiV1ArticlesArticleGet(
        requestParameters: GetArticleApiV1ArticlesArticleGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ResponseGetArticleApiV1ArticlesArticleGet> {
        const response = await this.getArticleApiV1ArticlesArticleGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve the available article types.
     * Get Article Types
     */
    async getArticleTypesApiV1ArticlesTypesGetRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/types`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Retrieve the available article types.
     * Get Article Types
     */
    async getArticleTypesApiV1ArticlesTypesGet(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<any> {
        const response = await this.getArticleTypesApiV1ArticlesTypesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get articles - admin route
     * Get Articles Admin
     */
    async getArticlesAdminApiV1ArticlesAdminGetRaw(
        requestParameters: GetArticlesAdminApiV1ArticlesAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListArticleAdminResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/admin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListArticleAdminResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get articles - admin route
     * Get Articles Admin
     */
    async getArticlesAdminApiV1ArticlesAdminGet(
        requestParameters: GetArticlesAdminApiV1ArticlesAdminGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListArticleAdminResponse> {
        const response = await this.getArticlesAdminApiV1ArticlesAdminGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get articles - public route
     * Get Articles
     */
    async getArticlesApiV1ArticlesGetRaw(
        requestParameters: GetArticlesApiV1ArticlesGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListArticleResponse>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/articles/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListArticleResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get articles - public route
     * Get Articles
     */
    async getArticlesApiV1ArticlesGet(
        requestParameters: GetArticlesApiV1ArticlesGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListArticleResponse> {
        const response = await this.getArticlesApiV1ArticlesGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve the featured article.
     * Get Featured Article
     */
    async getFeaturedArticleApiV1ArticlesArticleFeaturedGetRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/articles/article/featured`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGetFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve the featured article.
     * Get Featured Article
     */
    async getFeaturedArticleApiV1ArticlesArticleFeaturedGet(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet> {
        const response = await this.getFeaturedArticleApiV1ArticlesArticleFeaturedGetRaw(
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Publish article
     * Publish Article
     */
    async publishArticleApiV1ArticlesArticlePublishPostRaw(
        requestParameters: PublishArticleApiV1ArticlesArticlePublishPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ArticleAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling publishArticleApiV1ArticlesArticlePublishPost().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/article/publish`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ArticleAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Publish article
     * Publish Article
     */
    async publishArticleApiV1ArticlesArticlePublishPost(
        requestParameters: PublishArticleApiV1ArticlesArticlePublishPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ArticleAdminModel> {
        const response = await this.publishArticleApiV1ArticlesArticlePublishPostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Sets the specified article as the featured article.
     * Set Featured Article
     */
    async setFeaturedArticleApiV1ArticlesArticleSetFeaturedPutRaw(
        requestParameters: SetFeaturedArticleApiV1ArticlesArticleSetFeaturedPutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setFeaturedArticleApiV1ArticlesArticleSetFeaturedPut().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/article/set-featured`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Sets the specified article as the featured article.
     * Set Featured Article
     */
    async setFeaturedArticleApiV1ArticlesArticleSetFeaturedPut(
        requestParameters: SetFeaturedArticleApiV1ArticlesArticleSetFeaturedPutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<any> {
        const response = await this.setFeaturedArticleApiV1ArticlesArticleSetFeaturedPutRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Unpublish article
     * Unpublish Article
     */
    async unpublishArticleApiV1ArticlesArticleUnpublishPostRaw(
        requestParameters: UnpublishArticleApiV1ArticlesArticleUnpublishPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ArticleAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unpublishArticleApiV1ArticlesArticleUnpublishPost().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/article/unpublish`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ArticleAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Unpublish article
     * Unpublish Article
     */
    async unpublishArticleApiV1ArticlesArticleUnpublishPost(
        requestParameters: UnpublishArticleApiV1ArticlesArticleUnpublishPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ArticleAdminModel> {
        const response = await this.unpublishArticleApiV1ArticlesArticleUnpublishPostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update article
     * Update Article
     */
    async updateArticleApiV1ArticlesArticlePutRaw(
        requestParameters: UpdateArticleApiV1ArticlesArticlePutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ArticleAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateArticleApiV1ArticlesArticlePut().',
            );
        }

        if (requestParameters['articleUpdateModel'] == null) {
            throw new runtime.RequiredError(
                'articleUpdateModel',
                'Required parameter "articleUpdateModel" was null or undefined when calling updateArticleApiV1ArticlesArticlePut().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/articles/article`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ArticleUpdateModelToJSON(requestParameters['articleUpdateModel']),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ArticleAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Update article
     * Update Article
     */
    async updateArticleApiV1ArticlesArticlePut(
        requestParameters: UpdateArticleApiV1ArticlesArticlePutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ArticleAdminModel> {
        const response = await this.updateArticleApiV1ArticlesArticlePutRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
